import styled from 'styled-components';

import { COLORS, SPACE } from '../../../../theme/tokens';

export const Chip = styled.span`
  display: inline-flex;
  align-items: center;
  gap: ${SPACE[4]};
  max-width: 100%;
  min-width: 0;
  padding: ${SPACE[4]} ${SPACE[12]};
  border-radius: 999px;
  border: 1px solid ${COLORS.hairline};
  background: ${COLORS.surfaceCard};
  color: ${COLORS.textMuted};
  font-size: 12px;
  font-weight: 600;
  line-height: 1.2;

  svg {
    flex: none;
  }
`;

export const Label = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const Name = styled.span`
  color: ${COLORS.textBright};
`;
